module.exports = __webpack_public_path__ + "static/media/correct.fb31a23a.wav";